export const FALLBACK_STEP = 'undefined step';
export const FALLBACK_STEP_NAME = 'undefined stepName';
export const FALLBACK_TOOL_NAME = 'undefined toolName';
export const FALLBACK_LIST_NAME = 'undefined listName';
